export interface IPlugin {
	name: string;
	init(): void;
}

const initializedPlugins: IPlugin[] = [];
export const initPluggins = (...plugins: IPlugin[]): void =>{
	plugins.forEach(plugin => {
		if (initializedPlugins.indexOf(plugin) !== -1)
			return;

		plugin.init();

		initializedPlugins.push(plugin)
	});
}